export default "__VITE_ASSET__CS6Sp1Fx__"